import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { PrivateRoute } from "./auth";
import { useEffect } from "react";
// Shared pages
import Login from "./cbt_lms/login";
import SignUp from "./cbt_lms/sign_up_";
import PasswordReset from "./cbt_lms/password_reset";
import PasswordResetForm from "./cbt_lms/change_password";
import Receipt from "./cbt_lms/admin/receipt";
import { QrsCbtPassCodeVerification } from "./cbt_lms/q_code_page";

// Creator pages
import Admindashboard from "./cbt_lms/admin/dashboard";
import { TestResult } from "./cbt_lms/admin/test_result";
import { TestData } from "./cbt_lms/admin/test_data";
import { Cbt } from "./cbt_lms/admin/create_cbt";
import { CbtData } from "./cbt_lms/admin/cbt_data";
import { CbtImgLibrary } from "./cbt_lms/admin/img_library";
import { CbtQuestionEdit } from "./cbt_lms/admin/cbt_question_edit";
import Apikey from "./cbt_lms/admin/Apikey";
import PaymentPage from "./cbt_lms/admin/PaymentPage";
import OfflineExport from "./cbt_lms/admin/OfflineExport";
import Analytics from "./cbt_lms/admin/analytics";
import Profile from "./cbt_lms/profile";
import ViewImportedStudents from "./cbt_lms/admin/ViewImportedStudents";
import ExcelUpload from "./cbt_lms/admin/ExcelUpload";
import QuestionTransfer from "./cbt_lms/admin/QuestionTransfer";
import LabelSelector from "./cbt_lms/admin/LabelSelector";
import CbtList from './cbt_lms/admin/CbtList';
import CbtCreate from './cbt_lms/admin/CbtCreate';
import CbtEdit from './cbt_lms/admin/CbtEdit';
import CbtQuestionCreate from './cbt_lms/admin/CbtQuestionCreate';
import ImportQuestionsPage from "./cbt_lms/admin/ImportQuestionsPage";
import CreatorLogin from './cbt_lms/CreatorLogin';
import CryptoPayment from "./cbt_lms/admin/CryptoPayment";
import SubscriptionUsers from "./cbt_lms/admin/SubscriptionUsers";
import UserInvitations from "./cbt_lms/admin/UserInvitations";
import AllInvitationsDashboard from "./cbt_lms/admin/AllInvitationsDashboard";
function App() {

    function ExternalRedirect() {
    useEffect(() => {
      window.location.href = "https://cbthost.com";
    }, []);
    return null;
  }
  


  return (
    <HelmetProvider>
      <BrowserRouter>
        <Routes>

          {/* Shared Routes */}
          <Route path="/login" element={<CreatorLogin />} />
          <Route path="/sign-up" element={<SignUp />} />
          <Route path="/password-reset" element={<PasswordReset />} />
          <Route path="/password-reset-form" element={<PasswordResetForm />} />
          <Route path="/qr_verification" element={<QrsCbtPassCodeVerification />} />
          <Route path="/receipt/:reference" element={<Receipt />} />

          <Route path="/" element={<Navigate to="/login" replace />} />
           <Route path="*" element={<ExternalRedirect />} />
          {/* Creator Protected */}
          <Route path="/cbt_creator" element={<PrivateRoute />}>

            <Route path="dashboard" element={<Admindashboard />} />
            <Route path="cbt_data" element={<CbtData />} />
            <Route path="create_cbt" element={<Cbt />} />
            <Route path="cbt_question_edit" element={<CbtQuestionEdit />} />
            <Route path="cbt_img_library" element={<CbtImgLibrary />} />
            <Route path="api_key" element={<Apikey />} />
            <Route path="payment" element={<PaymentPage />} />
            <Route path="analytics" element={<Analytics />} />
            <Route path="profile" element={<Profile />} />

            <Route path="test_result/:cbt_pss_code" element={<TestResult />} />
            <Route path="test_data/:cbt_pass_code/:cbt_test_id/:user_id" element={<TestData />} />

            <Route path="offline-export" element={<OfflineExport />} />
            <Route path="imported-students/:cbt_pss_code" element={<ViewImportedStudents />} />
            <Route path="test_data_upload/:cbt_pss_code" element={<ExcelUpload />} />
            <Route path="question_transfer" element={<QuestionTransfer />} />
            <Route path="label-selector" element={<LabelSelector />} />
            <Route path="cbts" element={<CbtList />} />
            <Route path="cbt-create" element={<CbtCreate />} />
            <Route path="cbt-edit/:cbt_data_id" element={<CbtEdit />} />
            <Route path="cbt-question-create" element={<CbtQuestionCreate />} />
            <Route path="import-questions/:cbt_data_id" element={<ImportQuestionsPage />} />
            <Route path="crypto-payment/:invoiceId" element={<CryptoPayment />} /> 
            <Route path="subscription/users" element={<SubscriptionUsers />} /> 
            <Route path="all-invitations" element={<UserInvitations />} /> 
            <Route path="subscription/invitations" element={<AllInvitationsDashboard />} /> 
         
          </Route>

        </Routes>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;